export default __webpack_public_path__ + "static/media/1.764e1142.png";